import { createFileRoute } from '@tanstack/react-router';
import { DirectoryPage } from '@/features/employees/directory-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/employees/')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/employees');
  },
  component: DirectoryPage,
});
